import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as MypageRequestApi from '../Api/MypageRequestApi';
import * as SchoolApi from '../Api/SchoolApi';

import * as rent_customer_contacts_api from '../Api/rent_customer_contacts_api';
export interface MapSearchState {
    mypage_request: any;
    coming_comp: boolean;
    shougakkou_list: any[];
    chuugakkou_list: any[];
    shougakkou_loading: boolean;
    chuugakkou_loading: boolean;
    shougakkou_error: string;
    chuugakkou_error: string;
    // search_rooms_detail:any;
}
const initialState: MapSearchState = {

    mypage_request: {},
    coming_comp: false,
    shougakkou_list: [],
    chuugakkou_list: [],
    shougakkou_loading: false,
    chuugakkou_loading: false,
    shougakkou_error: '',
    chuugakkou_error: '',
    // search_rooms_detail: [],
}



///action 
const actionCreator = actionCreatorFactory();

export const get_mypage_request = actionCreator('GET_MYPAGE_REQUEST');
export const change_mypage_request = actionCreator<any>("CHANGE_MYPAGE_REQUEST");
export const update_mypage_request = actionCreator<any>('UPDATE_MYPAGE_REQUEST');
export const change_coming_comp = actionCreator<any>("CHANGE_COMING_COMP");
export const get_shougakkou_list = actionCreator('GET_SHOUGAKKOU_LIST');
export const change_shougakkou_list = actionCreator<any[]>('CHANGE_SHOUGAKKOU_LIST');
export const fail_shougakkou_list = actionCreator<string>('FAIL_SHOUGAKKOU_LIST');
export const get_chuugakkou_list = actionCreator('GET_CHUUGAKKOU_LIST');
export const change_chuugakkou_list = actionCreator<any[]>('CHANGE_CHUUGAKKOU_LIST');
export const fail_chuugakkou_list = actionCreator<string>('FAIL_CHUUGAKKOU_LIST');


// export const get_search_rooms_detail= actionCreator('GET_SEARCH_ROOMS_DETAIL');
// export const get_search_rooms_detail_success = actionCreator("GET_SEARCH_ROOMS_DETAIL_SUCCESS");


export const comingReducer = reducerWithInitialState(initialState)
    .case(change_mypage_request, (state, payload) => ({ ...state, mypage_request: payload }))
    .case(change_coming_comp, (state, payload) => ({ ...state, coming_comp: payload }))
    .case(get_shougakkou_list, state => ({ ...state, shougakkou_loading: true, shougakkou_error: '' }))
    .case(change_shougakkou_list, (state, payload) => ({ ...state, shougakkou_list: payload, shougakkou_loading: false }))
    .case(fail_shougakkou_list, (state, payload) => ({ ...state, shougakkou_list: [], shougakkou_loading: false, shougakkou_error: payload }))
    .case(get_chuugakkou_list, state => ({ ...state, chuugakkou_loading: true, chuugakkou_error: '' }))
    .case(change_chuugakkou_list, (state, payload) => ({ ...state, chuugakkou_list: payload, chuugakkou_loading: false }))
    .case(fail_chuugakkou_list, (state, payload) => ({ ...state, chuugakkou_list: [], chuugakkou_loading: false, chuugakkou_error: payload }))

// .case(get_search_rooms_detail_success, (state, payload) => ({ ...state, search_rooms_detal: payload }))
// .case(get_room_details_success, (state, payload) => ({ ...state, room_details: payload }))

// .case(get_response_rooms_success, (state, payload) => ({ ...state, response_rooms: payload }))

// .case(change_showRight, (state, payload) => ({ ...state, showRight: payload }))
// .case(change_showFlag, (state, payload) => ({ ...state, showFlag: payload }))
// .case(change_draggable, (state, payload) => ({ ...state, draggable: payload }))

// .case(get_rooms_success, (state, payload) => ({ ...state, rooms: payload }));








// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const comingSaga = [takeEvery('GET_MYPAGE_REQUEST', handle_get_mypage_request),
takeEvery('UPDATE_MYPAGE_REQUEST', handle_update_mypage_request),
takeEvery('GET_SHOUGAKKOU_LIST', handle_get_shougakkou_list),
takeEvery('GET_CHUUGAKKOU_LIST', handle_get_chuugakkou_list),


    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];

const normalizeSchoolList = (payload: any, type: 'shougakkou' | 'chuugakkou') => {
    const list = Array.isArray(payload) ? payload : (payload && Array.isArray(payload.data) ? payload.data : []);
    const idKeys = type === 'shougakkou'
        ? ['value', 'shougakkouNo', 'shougakkou_No', 'Shougakkou_No', 'shougakkouId', 'shougakkou_Id', 'Shougakkou_Id']
        : ['value', 'chuugakkouNo', 'chuugakkou_No', 'Chuugakkou_No', 'chuugakkouId', 'chuugakkou_Id', 'Chuugakkou_Id'];
    const nameKeys = type === 'shougakkou'
        ? ['label', 'shougakkouName', 'shougakkou_Name', 'Shougakkou_Name']
        : ['label', 'chuugakkouName', 'chuugakkou_Name', 'Chuugakkou_Name'];

    return list.map((item: any) => {
        const idKey = idKeys.find(key => item[key] !== undefined && item[key] !== null);
        const nameKey = nameKeys.find(key => item[key] !== undefined && item[key] !== null);
        return {
            value: idKey ? Number(item[idKey]) : null,
            label: nameKey ? String(item[nameKey]).trim() : ''
        };
    }).filter((item: any) => item.value !== null && item.label !== '');
};

function* handle_get_shougakkou_list() {
    const { payload, error } = yield call(SchoolApi.shougakkouList);
    if (!error) {
        yield put(change_shougakkou_list(normalizeSchoolList(payload, 'shougakkou')));
    } else {
        yield put(fail_shougakkou_list(error.message || String(error)));
    }
}

function* handle_get_chuugakkou_list() {
    const { payload, error } = yield call(SchoolApi.chuugakkouList);
    if (!error) {
        yield put(change_chuugakkou_list(normalizeSchoolList(payload, 'chuugakkou')));
    } else {
        yield put(fail_chuugakkou_list(error.message || String(error)));
    }
}
// export default masterSaga;



function* handle_get_mypage_request(action: any) {

    const { payload, error } = yield call(MypageRequestApi.detail, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // const setsubis = payload.map((item:any, i:number) => ({
        //     value: item.setsubiNo,
        //     label: item.setsubiName,
        //   }))

        // 成功時アクション呼び出し


        yield put(change_mypage_request(payload));

        // yield put(get_search_rooms_success(payload));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handle_update_mypage_request(action: any): any {
    const state = yield select();

    // alert(state.masterReducer.cd.cd)
    // return

    const { payload, error } = yield call(MypageRequestApi.update, {request:state.Coming.mypage_request, cd:state.masterReducer.cd.cd});

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // const setsubis = payload.map((item:any, i:number) => ({
        //     value: item.setsubiNo,
        //     label: item.setsubiName,
        //   }))

        // 成功時アクション呼び出し


        yield put(change_coming_comp(true));


        yield call(rent_customer_contacts_api.autodelete, state.Coming.mypage_request.responseCode);
        //    yield put(get_search_rooms_detail_success(payload));

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}
